/**
 * components/Nav — the app navigation, one config rendered two ways: a vertical rail
 * on desktop and a fixed bottom bar on mobile (both driven by the same route list, so
 * they never drift). Active state comes from the router's NavLink.
 */
import { NavLink } from 'react-router-dom';

export interface NavRoute {
  readonly to: string;
  readonly label: string;
  readonly icon: string;
}

export const NAV_ROUTES: readonly NavRoute[] = [
  { to: '/', label: 'Overview', icon: '◎' },
  { to: '/positions', label: 'Positions', icon: '⊞' },
  { to: '/analytics', label: 'Analytics', icon: '▦' },
  { to: '/funnel', label: 'Funnel', icon: '▽' },
  { to: '/decisions', label: 'Decisions', icon: '⚖' },
  { to: '/trades', label: 'Trades', icon: '⇅' },
  { to: '/stats', label: 'Stats', icon: '▤' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

export function NavRail(): JSX.Element {
  return (
    <nav className="nav-rail" aria-label="Primary">
      {NAV_ROUTES.map((r) => (
        <NavLink
          key={r.to}
          to={r.to}
          end={r.to === '/'}
          className={({ isActive }) => `nav-item${isActive ? ' is-active' : ''}`}
        >
          <span className="nav-item__icon" aria-hidden>{r.icon}</span>
          <span>{r.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export function NavBottom(): JSX.Element {
  return (
    <nav className="nav-bottom" aria-label="Primary">
      {NAV_ROUTES.map((r) => (
        <NavLink
          key={r.to}
          to={r.to}
          end={r.to === '/'}
          className={({ isActive }) => `nav-bottom__item${isActive ? ' is-active' : ''}`}
        >
          <span className="nav-bottom__icon" aria-hidden>{r.icon}</span>
          <span>{r.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
